export interface ProjectSpotValue {
  projectId?: number;
  projectName?: string;
  spotId?: number | null;
  spotPublicId?: number | null;
  spotName?: string;
  spotCategoryId?: number | null;
  spotTenantId?: number | null;
  categoryId?: number | null;
  tntInstId?: number | null;
}

/** 将资源中心类目接口结果转换为下拉选项，保留接口返回的一级类目。 */
export function normalizeSpotCategoryOptions(response: any): any[] {
  return Array.isArray(response) ? response : (Array.isArray(response?.data) ? response.data : []);
}

/** 合并接口各一级类目的 childList，作为平铺的二级项目类型选项。 */
export function normalizeProjectCategoryOptions(response: any): { name: string; id: number }[] {
  return normalizeSpotCategoryOptions(response).flatMap(category => (
    Array.isArray(category.childList) ? category.childList.map(child => ({ name: child.name, id: child.id })) : []
  ));
}

/** 切换公共项目时不保留原点位的任何标识，重复选择当前项目不丢失编辑值。 */
export function selectProject(current: ProjectSpotValue, project: ProjectSpotValue): ProjectSpotValue {
  if (current.projectId === project.projectId) return current;
  return { projectId: project.projectId, projectName: project.projectName };
}

/** 双 ID 和所属租户必须来自同一条查询记录，禁止使用项目副本 ID。 */
export function selectSpot(current: ProjectSpotValue, spot: ProjectSpotValue): ProjectSpotValue {
  return {
    projectId: current.projectId,
    projectName: current.projectName,
    spotId: spot.spotId,
    spotPublicId: spot.spotPublicId,
    spotName: spot.spotName,
    spotCategoryId: spot.spotCategoryId ?? spot.categoryId,
    spotTenantId: spot.spotTenantId,
  };
}

export function validateProjectSpot(value: ProjectSpotValue | undefined, required: boolean): string | undefined {
  const hasSelection = value && Object.values(value).some(item => item !== undefined && item !== null && item !== '');
  if (!required && !hasSelection) return undefined;
  if (!value?.projectId) return '请选择项目';
  if (!value.spotName?.trim()) return '请选择点位';
  const hasSpot = value.spotId !== undefined && value.spotId !== null;
  const hasPublicSpot = value.spotPublicId !== undefined && value.spotPublicId !== null;
  if (hasSpot !== hasPublicSpot) return '点位信息不完整，请重新选择点位';
  if (!hasSpot && !(value.spotCategoryId || value.categoryId)) return '点位类目信息缺失，请重新选择点位';
  return undefined;
}
